module.exports = "//static.hsappstatic.net/FileManagerImages/static-1.6823/images/empty-folder.svg"